import { Entry } from 'contentful'

export type ContentfulITag = Entry<any>

type TagLikeFields = { name?: string; urlTag?: string }

export type ITag = {
  id: string
  label: string
  urlTag: string
}

/**
 * Function to map Contentful Tags to an object with id and label
 * @param  {ContentfulITag[]} tags array of contentful Tags, Should contain a name field
 *
 * returns [{id: "test", label: "test label"}]
 */
export const mapTags = (tags: ContentfulITag[]): ITag[] =>
  !!tags &&
  tags
    .filter((tag) => tag && (tag.fields as TagLikeFields)?.name)
    .map((tag) => {
      const fields = tag.fields as TagLikeFields
      return { label: fields.name, id: tag.sys.id, urlTag: fields.urlTag }
    })
